var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.metros.length
    ? _c(
        "div",
        { staticClass: "ui-metro" },
        [
          _c("ui-select", {
            attrs: {
              required: _vm.required,
              label: _vm.label,
              options: _vm.metros,
              "empty-value": "Не выбрана",
              placeholder: "Выберите станцию метро"
            },
            on: {
              change: function($event) {
                return _vm.$emit("change", $event)
              }
            },
            model: {
              value: _vm.currentId,
              callback: function($$v) {
                _vm.currentId = $$v
              },
              expression: "currentId"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }